<template>
    <div class="index_wrap app">
        <el-container>
            <el-header class="index_header">
                <div class="index_title">
                    <el-image src="https://jcyunxp-v2024-local.oss-cn-shenzhen.aliyuncs.com/logo3_256.png"
                        style="width:36px;height:36px;margin-right:10px;"></el-image>
                    <div>捷晨云选片</div>
                </div>
                <div class="index_subtitle">摄影行业简洁高效的在线选片软件</div>
            </el-header>
            <el-main class="index_main">
                <div class="index_download">
                    <div>
                        <el-card shadow="hover" :body-style="{ padding: '30px 30px 20px 30px' }">
                            <div>最新版本：<el-tag size="mini" type="primary">{{ updater.version }} windows</el-tag> <el-tag
                                    size="mini" type="success" style="margin-left:10px;">{{ updater_mac.version }}
                                    macOS</el-tag></div>
                            <div>文件大小：<el-tag size="mini" type="primary">{{ updater.size }}</el-tag> <el-tag size="mini"
                                    type="success" style="margin-left:10px;">{{ updater_mac.size }}</el-tag></div>
                            <div>更新时间：
                                <span v-if="updater.releaseDate != updater_mac.releaseDate">
                                    <el-tag size="mini" type="primary">{{ updater.releaseDate }}</el-tag><el-tag size="mini"
                                        type="success" style="margin-left:10px;">{{ updater_mac.releaseDate }}</el-tag>
                                </span>
                                <span v-else>
                                    <el-tag size="mini" type="info">{{ updater.releaseDate }}</el-tag>
                                </span>
                            </div>
                            <div style="word-wrap:break-word;word-break:break-all;">支持系统：windows x64、macOS x64</div>
                            <p style="word-wrap:break-word;word-break:break-all;display: none;">SHA：{{ updater.sha512 }}</p>
                            <div style="color:rgb(255, 197, 159)">支持旧版云选片微信小程序转移剩余客单</div>
                            <div style="margin-top:15px;width:100%;">
                                <el-button :loading="!updater.path" type="primary" size="big" style="width:100%;"
                                    @click="downit" icon="el-icon-download">
                                    {{ download_text }}
                                </el-button>
                            </div>
                            <div style="margin-top:15px;width:100%;">
                                <el-button :loading="!updater_mac.path" type="success" size="big" style="width:100%;"
                                    @click="downit_mac" icon="el-icon-download">
                                    {{ download_text_mac }}
                                </el-button>
                            </div>
                            <div style="margin-top:15px;width:100%;">
                                <el-button :loading="!updater_mac.path_arm64" type="warning" size="big" style="width:100%;"
                                    @click="downit_mac_arm64" icon="el-icon-download">
                                    {{ download_text_mac_arm64 }}
                                </el-button>
                            </div>

                            <div align="right">
                                <el-link :underline="false" style="margin-top:15px;" type="warning" :href="douyin_help_src"
                                    target="_blank" icon="el-icon-video-play">管理端视频教程</el-link>
                                <el-link :underline="false" style="margin-top:15px;margin-left:20px;" type="primary"
                                    href="https://yxp.xpjckj.cn/?p=ZGVtbw" target="_blank">{{ isphone ? '选片示例' : '电脑端选片示例'
                                    }}</el-link>
                                <el-popover v-if="!isphone" placement="bottom" width="120" trigger="hover">
                                    <div align="center">
                                        <el-image :src="$qrcode_src + encodeURIComponent('https://yxp.xpjckj.cn/?p=ZGVtbw')"
                                            style="width:100%;border-radius:4px;"></el-image>
                                        <div>支持任意APP扫码打开</div>
                                    </div>
                                    <el-link :underline="false" slot="reference" style="margin-top:15px;margin-left:20px;"
                                        type="primary">移动端选片示例</el-link>
                                </el-popover>
                            </div>
                            <a id="downpath" :href="updater.path" target="_blank" style="display:none;"></a>
                            <a id="downpath_mac" :href="updater_mac.path" target="_blank" style="display:none;"></a>
                            <a id="downpath_mac_arm64" :href="updater_mac.path_arm64" target="_blank" style="display:none;"></a>
                        </el-card>
                    </div>
                </div>
                <el-divider content-position="center" v-if="update_logs.length != 0">核心功能</el-divider>
                <div class="index_desc">
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <el-collapse-item name="1">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>多端在线选片</p>
                            </template>
                            <p>一键分享选片链接，跨平台多人同时选片，电脑端、手机端、平板端均可选片，可远程线上选片、店内本地选片；</p>
                            <p>可设置可选数量、单张加片费用，同时自动计算总的加片费用；</p>
                            <p>不代收加片费，与客户用其它方式解决更科学；</p>
                            <p>选片链接可设置在自己的APP中，比如公众号，可引导客户关注后选片；</p>
                        </el-collapse-item>
                        <el-collapse-item name="2">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>一键快速导片</p>
                            </template>
                            <p>对客户标记好的照片可一键导出JPG图片、RAW原始档(包括XMP)；</p>
                        </el-collapse-item>
                        <el-collapse-item name="3">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>任务自动排期</p>
                            </template>
                            <p>选片任务名称只要包含日期，就能自动排期到日历，此日历采用标准iCalendar格式，可订阅到手机端日历并自动提醒；</p>
                            <p>可利用此功能提前创建任务，就能成为一个简洁的排期表；</p>
                            <p>手机端可显示当前的选片进度、选片密码、选片链接；</p>
                        </el-collapse-item>
                        <el-collapse-item name="3b">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>多渠道选片完成通知</p>
                            </template>
                            <p>除了默认的短信通知，还可以设置邮件通知、自定义推送。</p>
                            <p>注：自定义推送需要有server端开发能力。</p>
                        </el-collapse-item>
                        <el-collapse-item name="3a">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>云端照片管理</p>
                            </template>
                            <p>上传时可选上传部份底片，也可全选上传；</p>
                            <p>根据照片的EXIF信息自动旋转照片，对未正确识别的照片，可在云端手动旋转；</p>
                            <p>可删除云端不需要参与选片的照片；</p>
                            <p>可标记照片为推荐，让客户选片时具有参考性；</p>
                        </el-collapse-item>
                        <el-collapse-item name="4">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>水印版权保护</p>
                            </template>
                            <p>可自定义多个水印，针对每个选片任务可选不同的水印，包括满屏水印，更好保护您的照片；</p>
                        </el-collapse-item>
                        <el-collapse-item name="5">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>自定义标记组</p>
                            </template>
                            <p>可自定义多个标记组，针对每个选片任务可选不同的标记组，比如：入册、主框、副框、摆台、海报；</p>
                            <p>可自由排序标记，开启主标记后，当把照片标记为主框时，也能同时标记为入册；</p>
                        </el-collapse-item>
                        <el-collapse-item name="6">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>多员工管理</p>
                            </template>
                            <p>可配置多个员工登录使用，可自定义员工权限；</p>
                        </el-collapse-item>
                        <el-collapse-item name="7">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>服务器安全性</p>
                            </template>
                            <p>服务器在阿里云，图片上传后自动开启加密，更安全；</p>
                        </el-collapse-item>
                        <el-collapse-item name="8">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>无限的存储空间</p>
                            </template>
                            <p>图片上传时自动压缩，更好地保护原图在网络中泄露；</p>
                            <p>不限制每个用户的存储空间，若能在任务完成后主动删除选片任务，还有余额返还奖励；</p>
                        </el-collapse-item>
                        <el-collapse-item name="9">
                            <template slot="title">
                                <i class="header-icon el-icon-success"></i>
                                <p>灵活多样的套餐</p>
                            </template>
                            <p>有年费会员和按量付费套餐；</p>
                            <p>更有永久免费套餐，须老用户分享激活码进行激活；</p>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <el-divider content-position="center" v-if="update_logs.length != 0">更新日志</el-divider>
                <el-switch class="logs" style="display: block" v-model="logs_mac" active-color="#67C23A"
                    inactive-color="#409EFF" active-text="macOS" inactive-text="windows">
                </el-switch>
                <div class="index_updatelog" v-if="!logs_mac">
                    <template v-if="update_logs.length != 0">
                        <el-timeline v-for="(item, index) in update_logs"
                            :style="index != 0 ? 'opacity:0.9;' : 'opacity:0.9;'">
                            <el-timeline-item :timestamp="'v' + item.version + ' 更新于 ' + item.releaseDate" placement="top"
                                :type="index == 0 ? 'primary' : 'primary'" size="large">
                                <p class="index_notes" v-html="item.releaseNotes"></p>
                                <el-divider></el-divider>
                            </el-timeline-item>
                        </el-timeline>
                    </template>
                </div>
                <div class="index_updatelog" v-else>
                    <template v-if="update_logs_mac.length != 0">
                        <el-timeline v-for="(item, index) in update_logs_mac"
                            :style="index != 0 ? 'opacity:0.9;' : 'opacity:0.9;'">
                            <el-timeline-item :timestamp="'v' + item.version + ' 更新于 ' + item.releaseDate" placement="top"
                                :type="index == 0 ? 'success' : 'success'" size="large">
                                <p class="index_notes" v-html="item.releaseNotes"></p>
                                <el-divider></el-divider>
                            </el-timeline-item>
                        </el-timeline>
                    </template>
                </div>
                <el-backtop target=".index_wrap"></el-backtop>
            </el-main>
            <el-footer class="index_footer">
                <a href="https://beian.miit.gov.cn/" target="_blank">{{ $beian }}</a>
            </el-footer>
        </el-container>
    </div>
</template>
<script>
import api from "@/utils/api.js"
import request from "@/utils/request_other.js"
export default {
    name: 'webindex',
    props: {

    },
    data() {
        return {
            updater_url: 'https://yxp.xpjckj.cn/updater/',
            updater: {},
            updater_mac: {},
            update_logs: [],
            update_logs_mac: [],
            isphone: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            download_text: '下载Win管理端 Windows10及以上',
            download_text_mac: '下载macOS管理端 Intel芯片',
            download_text_mac_arm64: '下载macOS管理端 M1芯片',
            logs_mac: false,
            douyin_help_src: '',
            activeNames: ['1', '2', '3', '3a','3b', '4', '5', '6', '7', '8', '9']
        }
    },
    created() {
        document.title = '捷晨云选片'
        this.get_updater()
        this.get_updater_mac()
        this.get_douyin_help_src()
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        downit() {
            document.getElementById('downpath').click()
        },
        downit_mac() {
            document.getElementById('downpath_mac').click()
        },
        downit_mac_arm64() {
            document.getElementById('downpath_mac_arm64').click()
        },
        async get_douyin_help_src() {
            let data = {}
            let ret = await api.get_douyin_help_src(data)
            if (!ret || ret.code != 0) {
                return
            }
            this.douyin_help_src = ret.douyin_help_src
            console.log(this.douyin_help_src)
        },
        async get_updater() {
            let url = this.updater_url + 'latest.yml?rnd=' + new Date()
            let ret = await request({
                url: url,
                method: 'get'
            });
            if (ret) {
                let line = ret.split('\n')
                if (typeof (line) == 'object') {
                    //console.log(ret, line)
                    line.forEach(item => {
                        this.init_updater(item)
                    })
                }
                //console.log('updater_win=========', this.updater)
            }
            this.get_update_log()
        },
        async get_updater_mac() {
            let url = this.updater_url + 'latest-mac.yml?rnd=' + new Date()
            let ret = await request({
                url: url,
                method: 'get'
            });
            if (ret) {
                let line = ret.split('\n')
                if (typeof (line) == 'object') {
                    //console.log(ret, line)
                    line.forEach(item => {
                        this.init_updater_mac(item)
                    })
                }
                //console.log('updater_mac=========', this.updater_mac)
            }
            this.get_update_log_mac()
        },
        init_updater_mac(item) {
            item = item.trim()
            if (item.length == 0) return
            let pos = item.indexOf(':')
            let key = item.substr(0, pos).trim()
            let value = item.substr(pos + 1).trim()
            value = value.replace(/'/g, '')
            //console.log(key, value)
            if (key.length == 0 || value.length == 0) return
            if (key == 'size') {
                value = (value / 1024 / 1024).toFixed(2) + 'MB'
            }
            if (key == 'releaseDate') {
                value = value.substr(0, 10)
            }
            if (key == 'path') {
                value = this.updater_url + value
                this.$set(this.updater_mac, 'path_arm64', value.replace('x64.dmg','arm64.dmg'));
            }
            this.$set(this.updater_mac, key, value);
        },
        init_updater(item) {
            item = item.trim()
            if (item.length == 0) return
            let pos = item.indexOf(':')
            let key = item.substr(0, pos).trim()
            let value = item.substr(pos + 1).trim()
            value = value.replace(/'/g, '')
            //console.log(key, value)
            if (key.length == 0 || value.length == 0) return
            if (key == 'size') {
                value = (value / 1024 / 1024).toFixed(2) + 'MB'
            }
            if (key == 'releaseDate') {
                value = value.substr(0, 10)
            }
            if (key == 'path') {
                value = this.updater_url + value
            }
            this.$set(this.updater, key, value);
        },
        async get_update_log() {
            let data = {}
            let ret = await api.get_update_log(data)
            if (ret) {
                let logs = ret.split('\r\n\r\n')
                let tmp
                if (typeof (logs) == 'object') {
                    //console.log(logs)
                    logs.forEach(item => {
                        tmp = this.init_logs(item.split('\r\n'))
                        this.update_logs.unshift(tmp)
                    })
                }
                //console.log('update_logs', this.update_logs)
            } else {
                this.download_text = '暂停下载'
                this.updater.path = null
            }
        },
        async get_update_log_mac() {
            let data = {}
            let ret = await api.get_update_log_mac(data)
            if (ret) {
                let logs = ret.split('\r\n\r\n')
                let tmp
                if (typeof (logs) == 'object') {
                    //console.log(logs)
                    logs.forEach(item => {
                        tmp = this.init_logs(item.split('\r\n'))
                        this.update_logs_mac.unshift(tmp)
                    })
                }
                //console.log('update_logs_mac', this.update_logs_mac)
            } else {
                this.download_text_mac = '暂停下载'
                this.updater_mac.path = null
            }
        },
        init_logs(log) {
            let logs = {}
            log.forEach(item => {
                if (item) {
                    let pos = item.indexOf(':')
                    let key = item.substr(0, pos).trim()
                    let value = item.substr(pos + 1).trim()
                    if (key == 'releaseNotes') logs.releaseNotes = value
                    if (key == 'version') logs.version = value
                    if (key == 'releaseDate') {
                        value = value.replace(/'/g, '')
                        value = value.substr(0, 10)
                        logs.releaseDate = value
                    }
                    //console.log(logs)
                }
            })
            return logs
        },
    },
    mounted() {

    }
};
</script>
<style scoped>
.index_wrap {
    background-color: #3f3f3f;
    height: 100%;
    margin: 0;
    color: white;
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch;
}

.index_header {
    border-bottom: 1px solid rgb(83, 83, 83);
    background-color: #303030;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.index_title {
    letter-spacing: 10px;
    font-size: 20px;
    font-weight: bold;
    color: rgb(219, 219, 219);
    margin-left: 30px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.index_subtitle {
    margin-right: 30px;
    font-style: italic;
    font-weight: 100;
    color: #979797;
    font-size: 14px;
    margin-bottom: 10px;
}

.index_footer {
    /* position: fixed;
    bottom: 0; */
    width: 100%;
    text-align: center;
    background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #303030;
    font-size: 14px;
    color: #979797;
}

.index_footer a,
.index_footer a:active,
.index_footer a:hover,
.index_footer a:visited {
    color: #979797;
}

.index_main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
}

.index_download {
    margin-top: 40px;
    line-height: 1.8em;
    font-size: 14px;
    margin-bottom: 40px;
}

.index_desc {
    margin-top: 10px;
    margin-bottom: 20px;
    width: 500px;
}

.header-icon {
    color: orange;
    margin-right: 4px;
}

::v-deep .el-collapse {
    border-top: none !important;
    border-bottom: none !important;
}

::v-deep .el-collapse-item__header {
    background-color: transparent !important;
    padding-left: 4px;
    color: #f1f1f1 !important;
    border: none !important;
    font-size: 16px;
}

::v-deep .el-collapse-item__wrap {
    background-color: transparent !important;
    border-bottom: none !important;
}

::v-deep .el-collapse-item__content {
    font-size: 13px;
    color: rgb(185, 185, 185);
    padding: 0 10px 10px 10px;
    line-height: 1.4em !important;
}

.index_updatelog {
    margin-top: 40px;
    padding-bottom: 50px;
    line-height: 1.5em;
    color: #dbdbdb;
    max-width: 500px;
}

.el-backtop {
    background-color: #dbdbdb;
}

.el-divider__text {
    background-color: #303030;
    padding: 4px 8px;
    font-weight: 500;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
}

.el-card {
    border-radius: 4px;
    border: 1px solid #4d4d4d;
    background-color: #303030;
    width: 500px;

}

ul {
    padding-inline-start: 20px;
    padding-inline-end: 10px;
}

@media screen and (max-width: 500px) {
    .index_title {
        letter-spacing: 2px;
        font-size: 18px;
        font-weight: bold;
        color: rgb(219, 219, 219);
        margin-left: 15px;
        margin-bottom: 15px;
    }

    .index_subtitle {
        margin-right: 15px;
        font-style: italic;
        font-weight: 100;
        color: #979797;
        font-size: 12px;
        margin-bottom: 15px;
    }

    .el-card {
        max-width: 340px;
    }

    .index_desc {
        max-width: 340px;
    }
}
</style>